import { createFileRoute, notFound, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { PostsList } from "@/components/admin-workspace/PostsList";
import { PostEditorWorkspace } from "@/components/admin-workspace/PostEditorWorkspace";
import type { ListRow } from "@/components/admin-workspace/model";

// DEV-ONLY design preview of the admin workspace with clearly labelled sample
// rows. Returns 404 in production builds and never writes anywhere.
// Delete this file once real content is imported.

const SAMPLE: ListRow[] = [
  { id: "s1", slug: "ornek-yapay-zeka", title_tr: "[Örnek] Yapay zekânın dili kime ait?", excerpt_tr: "Örnek özet — gerçek içerik değildir.", category: "AI & Society", tags: ["yapay-zeka"], published: true, published_at: "2026-09-22T09:00:00Z", created_at: "2026-09-20T09:00:00Z" },
  { id: "s2", slug: "ornek-veri-merkezleri", title_tr: "[Örnek] Veri merkezlerinin görünmeyen maliyeti", excerpt_tr: "", category: "AI & Society", tags: ["veri-merkezleri", "yapay-zeka"], published: false, published_at: null, created_at: "2026-09-15T09:00:00Z" },
  { id: "s3", slug: "ornek-cop31-notu", title_tr: "[Örnek] COP31 notu: müzakerelerde ilk gün", excerpt_tr: "Örnek özet.", category: "Climate & Systems", tags: [], published: true, published_at: "2026-09-08T09:00:00Z", created_at: "2026-09-08T09:00:00Z" },
  { id: "s4", slug: "ornek-yalnizlik", title_tr: "[Örnek] Yalnızlık ekonomisi", excerpt_tr: "Örnek özet.", category: "Human Futures", tags: ["yapay-zeka"], published: true, published_at: "2026-08-18T09:00:00Z", created_at: "2026-08-18T09:00:00Z" },
];

export const Route = createFileRoute("/yonetim-onizleme")({
  validateSearch: z.object({ ekran: z.enum(["liste", "duzenle"]).optional() }),
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound();
  },
  head: () => ({
    meta: [
      { title: "Yönetim paneli önizlemesi (örnek veri)" },
      { name: "description", content: "Geliştirme ortamına özel yönetim paneli tasarım önizlemesi." },
      { property: "og:title", content: "Yönetim paneli önizlemesi" },
      { property: "og:description", content: "Geliştirme ortamına özel önizleme." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: Preview,
});

function Preview() {
  const { ekran } = Route.useSearch();
  const navigate = useNavigate();
  const banner = (
    <p className="bg-clay/15 px-4 py-2 text-center text-xs text-ink">Tasarım önizlemesi · örnek veri · hiçbir şey kaydedilmez</p>
  );
  if (ekran === "duzenle") {
    return (
      <>
        {banner}
        <PostEditorWorkspace
          initial={{ ...SAMPLE[1], excerpt_tr: "", content_tr: "<p>Örnek gövde metni. Bu paragraf yalnızca düzenleyicinin görünümünü göstermek içindir.</p><h2>Örnek ara başlık</h2><p>İkinci örnek paragraf, <a href=\"https://example.com\">örnek bağlantı</a> içerir.</p>", title_en: "", content_en: "", excerpt_en: "", cover_image_url: null, show_on_home: true, tags: SAMPLE[1].tags ?? [] }}
          allPosts={SAMPLE}
          onBack={() => navigate({ to: "/yonetim-onizleme", search: { ekran: "liste" }, ignoreBlocker: true })}
          onSave={(p) => new Promise((r) => setTimeout(() => r({ id: p.id ?? "s-new", slug: p.slug }), 500))}
        />
      </>
    );
  }
  return (
    <div className="min-h-screen bg-paper text-ink">
      {banner}
      <div className="px-4 py-8 md:px-10">
        <PostsList posts={SAMPLE} onOpen={() => navigate({ to: "/yonetim-onizleme", search: { ekran: "duzenle" } })} onNew={() => navigate({ to: "/yonetim-onizleme", search: { ekran: "duzenle" } })} />
      </div>
    </div>
  );
}
